import { NgModule } from '@angular/core';

import { OAuthService } from './oAuth.service';

@NgModule({
    providers: [OAuthService]
})
export class OAuthModule {}
